/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:f864577b-5f50-49b4-93fa-c058d3fd24c9",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_mCYFRkiFI",
    "aws_user_pools_web_client_id": "4ik21qahmpsp2r8ee2r6q0lden",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://g77idcnbbbdsjcmcvjxn6r6jre.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
